<template>
  <div>
    <template v-if="isLoading">
      <div class="text-center p-5 card">
        <div
          class="d-inline align-self-center justify-self-center loader"
        />
      </div>
    </template>
    <template v-else>
      <template v-if="!selectedGroupId">
        <div
          class="text-center p-5 card"
        >
          Please select a template group
        </div>
      </template>
      <template v-else>
        <div
          class="card mb-0 p-4"
          v-for="(item, index) in templateList"
          :key="`item-${index}`"
        >
          <b-row>
            <b-col
              class="d-flex justify-content-center"
              cols="3"
            >
              <label
                class="d-flex flex-column align-self-center m-0 ml-5"
                :id="`template-rotation-${item.id}`"
              >
                <input
                  type="checkbox"
                  :name="`template-checkbox${item.id}`"
                  class="custom-switch-input"
                  :id="item.id"
                  data-test="template-checkbox"
                  :checked="selected.includes(item.id)"
                  :value="item.id"
                  :disabled="disabled || (selected.length < 2 && selected.includes(item.id))"
                  @change="updateTemplatesSelected"
                >
                <span class="custom-switch-indicator" />
              </label>
            </b-col>
            <b-col>
              <div>
                <a
                  :href="`/templates/update/${item.id}`"
                  target="_blank"
                >
                  {{ item.name }}
                </a>
              </div>
              <div class="small text-muted">
                {{ `${item.width}x${item.height}` }}
              </div>
            </b-col>
          </b-row>
        </div>
      </template>
    </template>
  </div>
</template>
<script>

export default {
  name: 'TemplateGroupTemplates',
  props: {
    selectedGroupId: {
      type: Number,
      default: null,
    },
    templateList: {
      type: Array,
      default() {
        return [];
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selected: [],
      isLoading: true,
    };
  },
  methods: {
    getTemplatesInGroup() {
      this.isLoading = true;
      if (!this.selectedGroupId) {
        this.isLoading = false;
        return;
      }
      this.setTemplatesSelected(this.templateList);
      this.isLoading = false;
    },
    setTemplatesSelected(templateList) {
      this.selected = templateList
        .filter((item) => item.selected)
        .map((item) => item.id);
    },
    updateTemplatesSelected($event) {
      const templateId = Number($event.target.value);
      if ($event.target.checked) {
        if (!this.selected.includes(templateId)) this.selected.push(templateId);
      } else {
        this.selected = this.selected.filter((id) => id !== templateId);
      }
      this.$emit('updateTemplatesSelected', this.selected);
    },
  },
  created() {
    this.getTemplatesInGroup();
  },
};
</script>
<style scoped>
.custom-switch-input:disabled ~ .custom-switch-indicator {
  cursor: not-allowed;
  opacity: 0.4;
}
</style>
